<div class="flex items-center justify-center">
    <div class="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-blue-500" role="status">
    </div>
  </div>

  <style>

.spinner-border {
    vertical-align: -0.125em;
    border: 0.25em solid;
    border-right-color: transparent;
}
  </style>